<form [formGroup]="dividendInBox3">
        <div formArrayName="box3Dividend">
            <div *ngFor="let loon of box3Dividend.controls; let i = index; "
                          [formGroupName]="i" class="row">
                    <snelstart-ui-text-form-control formControlName="rekeningNummer"
                                                    id="rekeningNummer"
                                                    [label]="i === 0 ? 'Rekeningnummer' : ''"
                                                    class="col-auto custom-input-250"
                                                    (change)="saveForm()"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control formControlName="dividendBox3"
                                                      id="dividendBox3"
                                                      [label]="i === 0 ? 'Dividend' : ''"
                                                      class="col-auto custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      (change)="saveForm()"

                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="dividendbelastingBox3"
                                                      id="dividendbelastingBox3"
                                                      [label]="i === 0 ? 'Dividendbelasting' : ''"
                                                      class="col-auto custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      [required]=true
                                                      (change)="saveForm()"

                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button id="buttonDeleteKosten"
                                                type="secondary"
                                                size="medium"
                                                iconType="light"
                                                (click)="verwijderRijDividendBox3(i)"
                                                [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                    >
                    </snelstart-ui-button>
            </div>
        </div>
</form>

<div *ngIf="box3Dividend.length === 0">
    <snelstart-ui-button class="snelstart-ui-button pb-3" type="link" icon="plus"
                         (click)="addRijDividendBox3()">Dividendbelasting box 3 invullen
    </snelstart-ui-button>
</div>
<div *ngIf="box3Dividend.length > 0">
    <snelstart-ui-button class="snelstart-ui-button pb-3" type="link" icon="plus"
                         (click)="addRijDividendBox3()">Dividendbelasting box 3 toevoegen
    </snelstart-ui-button>
</div>

